import { Box, Card, CardContent, Chip, Stack } from "@mui/material";
import React, { memo, useEffect, useState } from "react";
import { motion } from "framer-motion";
import useResponsive from "../../../Hooks/useResponsive";

const TotalCountDisplay = memo(
  ({ totalStudents, assignedStudents, unAssignedStudents,totalCourses }) => {
    const [direction, setDirection] = useState("row");
    const mdDown = useResponsive("down", "md");
    useEffect(() => {
      if (mdDown) {
        setDirection("column");
      } else {
        setDirection("row");
      }
    }, [mdDown]);
    return (
      <Box>
        <motion.div
          initial={{ y: -200, x: 0, opacity: 0 }}
          animate={{ y: 0, x: 0, opacity: 1 }}
          transition={{ duration: 0.8 }}
        >
          <Card
            sx={{
              background:
                // "linear-gradient(135deg,rgba(0, 200, 255, 0.79),rgba(173, 194, 37, 0.55))",
                "linear-gradient(135deg, rgb(47 114 179), rgb(30 101 171 / 19%))",
              color: "#fff",
              borderRadius: 3,
              width: "100%",
              maxWidth: 900,
              // border:'1px solid #00000042'
            }}
          >
            <CardContent>
              <Stack spacing={1} direction={direction} justifyContent="center">
                {/* <Chip
                  variant="outlined"
                  label={`Total Students : ${totalStudents || 0}`}
                  sx={{
                    backgroundColor: "white",
                    color: "#000000",
                    fontWeight: 500,
                    fontSize: "1rem",
                  }}
                /> */}
                <Chip
                  variant="outlined"
                  label={`Assigned Students : ${assignedStudents || 0}`}
                  sx={{
                    backgroundColor: "white",
                    color: "#000000",
                    fontWeight: 500,
                    fontSize: "1rem",
                  }}
                />
                <Chip
                  variant="outlined"
                  label={`Un Assigned Students : ${unAssignedStudents || 0}`}
                  sx={{
                    backgroundColor: "white",
                    color: "#000000",
                    fontWeight: 500,
                    fontSize: "1rem",
                  }}
                />
                <Chip
                  variant="outlined"
                  label={`Total Courses : ${totalCourses || 0}`}
                  sx={{
                    backgroundColor: "white",
                    color: "#000000",
                    fontWeight: 500,
                    fontSize: "1rem",
                  }}
                />
              </Stack>
            </CardContent>
          </Card>
        </motion.div>
      </Box>
    );
  }
);

export default TotalCountDisplay;
